<template>
  <DnDContainer
    behaviour="copy"
    :get-child-payload="initMaterial"
  >
    <Draggable class="material">
      <slot>{{material.title}}</slot>
    </Draggable>
  </DnDContainer>
</template>

<script>
import { Container, Draggable } from 'vue-smooth-dnd'
export default {
  name: 'ICMobileMaterial',
  components: {
    DnDContainer: Container,
    Draggable
  },
  props: {
    material: {
      type: Object,
      require: true
    },
    init: Function
  },
  methods: {
    initMaterial () {
      return {
        ...this.material,
        id: Date.now(),
        title: `${this.material.title}${Date.now()}`
      }
    }
  }
}
</script>
<style>
